export default "__VITE_ASSET__D_HiEz1x__"